import React, { useEffect } from 'react';
import classnames from 'classnames';
import { ArrowIcon } from '../common-view';
import Title from './title';
/**
 *
 *
 * <Table.Group name="组名" extra="" >
 *  <Table.Column></Table.Column>
 * </Table.Group>
 *
 */
export default function Group(props) {
    const { name, extra, visible, defaultVisible, indent, children, onClick, className, } = props;
    const [_visible, setVisible] = React.useState(defaultVisible);
    useEffect(() => {
        setVisible(visible);
    }, [visible]);
    return (React.createElement("div", { "data-hottag": 'cn-op.table.group', className: classnames('op-table-group', className), style: { marginLeft: indent } },
        React.createElement("div", { className: 'op-table-group-title' },
            React.createElement("div", { className: classnames('op-table-group-title-icon', {
                    transform: _visible,
                }), onClick: () => {
                    setVisible(!_visible);
                    onClick && onClick(!_visible);
                } },
                React.createElement(ArrowIcon, { size: 18, color: '#196EE6' })),
            React.createElement(Title, null,
                React.createElement("div", null, name),
                React.createElement("div", null, extra))),
        _visible ? children : null));
}
